import classNames from 'classnames';
import styles from './ThumbnailCard.module.scss';
import { Picture } from 'ui/components';
import { Heading, RichText } from 'ui/components';

export interface ThumbnailCardProps {
	className?: string;
	image?: Umbraco.Image;
	columnWidth: Models.GridCellWidth;
	imageSizes: string;
	link?: Umbraco.Link;
	heading?: string;
	text?: string;
	interactiveText?: string;
}

export const ThumbnailCard: React.FC<ThumbnailCardProps> = ({
	className,
	image,
	link,
	heading,
	text,
	interactiveText,

	...props
}) => {
	const { imageSizes, columnWidth } = props || {};
	const textContent = interactiveText ? interactiveText : text; 
	const contentInner = (
		<>
			{image && (
				<div className={styles.ThumbnailCard_media}>
					<span className={styles.ThumbnailCard_mediabox}>
						<Picture
							className={styles.ThumbnailCard_picture}
							sizes={imageSizes}
							aspectRatio={0.75}
							relativeUrl={image?.relativeUrl}
							properties={image.properties}
							focalPoint={image.focalPoint}
						/>
					</span>
				</div>
			)}
			<div className={styles.ThumbnailCard_textbox}>
				<Heading className={styles.ThumbnailCard_heading} headingLevel="h3">
					{heading}
				</Heading>
				<RichText className={classNames(styles.ThumbnailCard_text, 'RichText', className)} content={textContent} />
			</div>
			<div></div>
		</>
	);

	let content;

	if (link) {
		content = (
			<a
				className={classNames(styles.ThumbnailCard, styles.ThumbnailCard___link, className)}
				href={link.url}
				target={link.target}
				title={link.name}
			>
				{contentInner}
			</a>
		);
	} else {
		content = <div className={classNames(styles.ThumbnailCard, className)}>{contentInner}</div>;
	}

	return content;
};
